import React from 'react';
import PhotoSlideshow from './components/PhotoSlideshow';
import LoveLetter from './components/LoveLetter';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto">
        <PhotoSlideshow />
        <LoveLetter />
      </div>
    </div>
  );
}

export default App;
